import Sortable, { SortableEvent } from 'sortablejs';
import { patch } from '@rails/request.js';

interface SortableOptions {
  group?: string | null;
}

export default ({ group = null }: SortableOptions = {}) => {
  let sortable: Sortable;

  return {
    init() {
      sortable = new Sortable(this.$root, {
        group: group,
        handle: '.handle',
        animation: 150,
        onEnd: this.onEnd,
      });
    },

    destroy() {
      sortable.destroy();
    },

    async onEnd({ item, newIndex, to }: SortableEvent) {
      if (!item.dataset.sortableUpdateUrl) {
        return;
      }

      const data = new FormData();
      if (to.dataset.sortableParentId) {
        data.append('parent_id', to.dataset.sortableParentId);
      }
      data.append('position', String((newIndex ?? 0) + 1));

      await patch(item.dataset.sortableUpdateUrl, {
        body: data,
      });
    },
  };
};
